/*
状态对象
 */
export default {
  userInfo: {}, // 用户信息
  existingAccountBindWeiXin: false, // 已有账号绑定微信还是新账号注册微信
  BindPhone: false, // 已有账号绑定微信还是新账号注册微信
  isLogin: null,
  userWeixin: {
    nickname: "",
    phone: "",
    avatar: "",
    openApplet: false,
  },
  license: "",
  clientele: {
    displayName: "",
    slogan: "",
    imageAddress: "",
    clienteleName: "",
    appImageAddress: "",
    watermark: "",
    themeColor: "",
  },
  // ip: "",
  // address: "",
};
